import { ImageUrlBuilder } from '@sanity/image-url/lib/types/builder';
import { ImageProps } from '../../bound/landingPage/Image';
import { imageUrl } from './sanity';
import { Dataset, SanityObject } from './types';

export const getPoster = (
    poster?: SanityObject<ImageProps>,
    dataset?: Dataset
): ImageUrlBuilder | undefined =>
    poster?.image !== undefined ? imageUrl(poster.image, dataset) : undefined;
